export const ALGOLIA_HISTORY = 'ALGOLIA_HISTORY';
